import React from 'react';
import { useTranslation } from 'react-i18next';
import ComparePage from './ComparePage';

const BANKS = [
  {
    name: 'Scotiabank',
    cardName: 'Scotiabank StartRight',
    cardData: {
      bank: 'Scotiabank',
      annual_fee: 'No annual fee',
      newcomer_friendly: true,
      rewards: '1% cash back on all eligible purchases',
    },
  },
  {
    name: 'TD',
    cardName: 'TD Cash Back Visa',
    cardData: {
      bank: 'TD',
      annual_fee: 'No annual fee',
      newcomer_friendly: true,
      rewards: '1% cash back on gas and groceries, 0.5% on all other purchases',
    },
  },
  {
    name: 'RBC',
    cardName: 'RBC Cash Back Mastercard',
    cardData: {
      bank: 'RBC',
      annual_fee: 'No annual fee',
      newcomer_friendly: true,
      rewards: '0.5% cash back on all purchases, up to 1% on groceries',
    },
  },
  {
    name: 'BMO',
    cardName: 'BMO CashBack Mastercard',
    cardData: {
      bank: 'BMO',
      annual_fee: 'No annual fee',
      newcomer_friendly: true,
      rewards: '0.5% cash back on all purchases',
    },
  },
];

const ROWS = [
  { label: 'Cuota anual', values: ['Sin cuota', 'Sin cuota', 'Sin cuota', 'Sin cuota'] },
  { label: 'Cash back', values: ['1% en todo', '1% gas/supermercado', 'Hasta 1% supermercados', '0.5% en todo'] },
  { label: 'Programa newcomer', values: ['StartRight', 'New to Canada', 'Newcomer Package', 'NewStart'] },
  { label: 'Soporte en espanol', values: ['Excelente', 'Bueno', 'Parcial', 'Parcial'] },
  { label: 'App movil', values: ['3.7/5', '4.0/5', '4.0/5', '3.8/5'] },
  { label: 'Red de sucursales', values: ['Amplia', 'Amplia', 'Amplia', 'Amplia'] },
  { label: 'Presencia LATAM', values: ['Si', 'No', 'No', 'No'] },
  { label: 'Transferencias internacionales', values: ['Tarifas preferenciales', 'Estandar', 'Estandar', 'Estandar'] },
];

const FAQS = [
  {
    question: '¿Cuál es el mejor banco en Canada para un recien llegado latino en 2026?',
    answer: 'Scotiabank es el mas recomendado para latinos por su soporte en espanol, presencia en Latinoamérica y tarjeta StartRight con 1% cash back sin cuota. TD es excelente segunda opcion por su programa New to Canada y soporte en espanol por telefono.',
  },
  {
    question: 'Puedo abrir una cuenta bancaria sin SIN number?',
    answer: 'Si. Los bancos canadienses estan obligados por ley a abrir cuentas bancarias basicas. Necesitas identificacion (pasaporte) y una direccion en Canada. El SIN number te lo pediran después para reportar intereses al CRA.',
  },
  {
    question: '¿Cuánto tarda en construir credit score en Canada?',
    answer: 'Con una tarjeta de credito usada responsablemente (menos de 30% del limite, pagando completo cada mes), puedes tener un credit score de 650+ en 6-12 meses. Los programas newcomer de estos bancos estan diseñados exactamente para esto.',
  },
];

const RELATED = [
  { to: '/comparar/rbc-vs-td-recien-llegados', label: 'RBC vs TD - comparacion detallada' },
  { to: '/comparar/scotiabank-vs-bmo-inmigrantes', label: 'Scotiabank vs BMO - comparacion detallada' },
  { to: '/comparar/rbc-vs-desjardins-quebec', label: 'RBC vs Desjardins para Quebec' },
  { to: '/primeros-pasos', label: 'Guia completa: primeros pasos financieros en Canada' },
];

const MejoresBancosPage = () => {
  const { i18n } = useTranslation();
  return (
  <ComparePage
    seoTitle="Mejores bancos para recien llegados en Canada 2026"
    seoDescription="Comparacion de los 4 mejores bancos para recién llegados a Canada: Scotiabank, TD, RBC y BMO. Programas newcomer, soporte en espanol y FinMaple Score."
    seoKey="compararMejores"
    noIndex={i18n.language !== 'es'}
    canonical="/comparar/mejores-bancos-recien-llegados-canada-2026"
    routeKey="compararMejores"
    breadcrumbLabel="Mejores bancos 2026"
    atomicAnswer="Los 4 mejores bancos para recien llegados en Canada en 2026 son Scotiabank (mejor para latinos por su soporte en espanol y presencia en LATAM), TD (excelente programa New to Canada), RBC (paquete newcomer completo) y BMO (opcion solida con programa NewStart). Todos ofrecen tarjetas sin cuota anual."
    banks={BANKS}
    comparisonRows={ROWS}
    veredicto="Scotiabank ocupa el primer lugar para inmigrantes latinoamericanos gracias a su combinacion unica de soporte en espanol, presencia en Latinoamérica para transferencias, y el mejor cash back (1%) sin cuota anual. TD es un segundo lugar muy cercano con mejor app movil y excelente programa newcomer. RBC y BMO son opciones solidas pero con menos diferenciacion para el publico latino. Nuestra recomendacion: abre tu primera cuenta en Scotiabank o TD, y solicita su tarjeta de credito newcomer para empezar a construir credit score desde el dia uno."
    faqs={FAQS}
    mayaText="Acabas de llegar a Canada y no sabes por dónde empezar? Preguntale a Maya - te guia paso a paso para abrir tu primera cuenta bancaria y tarjeta de credito."
    relatedLinks={RELATED}
  />
  );
};

export default MejoresBancosPage;
